import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingLabelsByInvoice': false,
  'labelsList': [],
  'labelsListByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const labelsReprint = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FECTHING_LABELS_BY_INVOICE]: (state, action) => ({
      ...state,
      'loadingLabelsByInvoice': true,
    }),
    [ActionTypes.FECTHED_LABELS_BY_INVOICE]: (state, action) => ({
      ...state,
      'loadingLabelsByInvoice': false,
      'labelsList': action.response.data,
      'labelsListByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FECTHED_LABELS_BY_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'loadingLabelsByInvoice': false,
      'labelsList': [],
      'labelsListByPage': [],
    }),
    [ActionTypes.CHANGE_LABELS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'labelsListByPage': [...getPage(state.labelsList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_LABELS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'labelsListByPage': [...getPage(state.labelsList, 0, action.payload)],
    }),
    [ActionTypes.EMPTY_LABELS]: (state, action) => ({
      ...state,
      'pageNumber': 0,
      'labelsList': [],
      'labelsListByPage': [],
    }),
  })(state, action);
};
